<template lang="pug" src="./custom-treatments-age.pug"></template>

<script>
import { onScroll } from 'resources/mixins'

export default {
  data () {
    return {
      show: 0,
      options: {
        root: null,
        rootMargin: '0px',
        threshold: [0.4]
      }
    }
  },
  props: ['props'],
  mixins: [onScroll],
  methods: {
    handleClick (i) {
      this.show = i
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/custom/custom-treatments-age/custom-treatments-age.vue